import React, { useEffect } from 'react';
import {
  Popover,
  Tag,
  DatePicker,
  Input,
  Typography,
  Button,
  InputNumber,
} from 'antd';
import dayjs from 'dayjs';
import UserAvatar from '../../../../components/userAvatar/index';
import { useDispatch, useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
//import {  setStoryPoints } from  'store/actions';

const DetailsPage = ({
  taskdata,
  assignee,
  setAssignee,
  assigneeOptions = [],
  labelOptions = [],
  labels = [],
  setLabels,
  epicOptions = [],
  epic,
  setEpic,
  dueDate,
  setDueDate,
  startDate,
  setStartDate,
  story_points,
  setStoryPoints,
  autoSave,
  handleAddLabel,
  subtaskDetails,
  autoSaveSubtask,
  subtaskLabelUpdate,
  projectId,
}) => {
  const { Title, Text } = Typography;

  const dispatch = useDispatch();
  const isSubtask = !!subtaskDetails?.subtask_id;

  useEffect(() => {
    if (isSubtask && subtaskDetails?.labels) {
      setLabels(subtaskDetails.labels);
    } else if (!isSubtask && taskdata?.labels) {
      setLabels(taskdata.labels);
    }
  }, [subtaskDetails, taskdata]);

  return (
    <>
      <div
        style={{
          flex: 1,
          borderLeft: '1px solid #eaeaea',
          padding: '20px',
          overflowY: 'auto',
          background: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
          gap: 18,
          border: '1px solid #e5e5e5',
        }}
      >
        {/* Assignee */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Assignee</span>
          <Popover
            placement="bottomLeft"
            trigger="click"
            overlayInnerStyle={{
              width: 240,
              maxHeight: 260,
              overflowY: 'auto',
              padding: 6,
            }}
            content={
              assigneeOptions.length > 0 ? (
                assigneeOptions.map((user) => (
                  <div
                    key={user.user_id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '6px 10px',
                      borderRadius: 6,
                      cursor: 'pointer',
                      background:
                        assignee === user.user_id ? '#e6f4ff' : 'transparent',
                      transition: 'background 0.2s',
                    }}
                    onClick={() => {
                      setAssignee(user.user_id);

                      if (isSubtask) {
                        autoSaveSubtask('assignee_id', user.user_id);
                      } else {
                        autoSave('assignee_id', user.user_id);
                      }
                    }}
                  >
                    <UserAvatar username={user.username} size={26} />
                    <Text style={{ fontSize: 14 }}>{user.username}</Text>
                  </div>
                ))
              ) : (
                <Text type="secondary">No employees found</Text>
              )
            }
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                cursor: 'pointer',
              }}
            >
              <UserAvatar
                username={
                  assigneeOptions.find((u) => u.user_id === assignee)
                    ?.username ||
                  subtaskDetails?.assignee_name ||
                  taskdata?.username ||
                  'Unassigned'
                }
                size={28}
              />
              <Text>
                {assigneeOptions.find((u) => u.user_id === assignee)
                  ?.username ||
                  subtaskDetails?.assignee_name ||
                  taskdata?.username ||
                  'Unassigned'}
              </Text>
            </div>
          </Popover>
        </div>

        {/* Labels */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Labels</span>
         <CreatableSelect
  isClearable
  isMulti
  placeholder="Select or create label"
  value={labels.map((l) => ({
    label: l.label_name,
    value: l.label_id,
    ...l,
  }))}

  options={labelOptions.map((l) => ({
    label: l.label_name,
    value: l.label_id,
    ...l,
  }))}

  onChange={(newValue) => {
    const updatedLabels = (newValue || []).map((item) => ({
      label_id: item.value,
      label_name: item.label,
    }));

    setLabels(updatedLabels);

    // ✅ keep subtask logic unchanged
    if (isSubtask) {
      subtaskLabelUpdate(updatedLabels);
    } else {
      handleAddLabel(updatedLabels);
    }
  }}
/>
        </div>

        {/* Parent (Epic) */}
        {!isSubtask && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <span style={{ width: 120, fontWeight: 500 }}>Parent</span>
            <Popover
              placement="bottomLeft"
              trigger="click"
              overlayInnerStyle={{
                width: 240,
                maxHeight: 260,
                overflowY: 'auto',
                padding: 6,
              }}
              content={
                epicOptions.length > 0 ? (
                  epicOptions.map((e) => (
                    <div
                      key={e.epic_id}
                      style={{
                        padding: '6px 10px',
                        borderRadius: 6,
                        cursor: 'pointer',
                        background:
                          epic === e.epic_id ? '#e6f4ff' : 'transparent',
                      }}
                      onClick={() => {
                        setEpic(e.epic_id);
                        // autoSave('epic_id', e.epic_id);

                        if (subtaskDetails) {
                          autoSaveSubtask('epic_id', e.epic_id);
                        } else {
                          autoSave('epic_id', e.epic_id);
                        }
                      }}
                    >
                      <Text style={{ fontSize: 14 }}>{e.epic_name}</Text>
                    </div>
                  ))
                ) : (
                  <Text type="secondary">No epics found</Text>
                )
              }
            >
              <div
                style={{
                  cursor: 'pointer',
                  padding: '4px 8px',
                  borderRadius: 4,
                  border: '1px solid #f0f0f0',
                  minWidth: 180,
                }}
              >
                <Text style={{ fontSize: 14 }}>
                  {epicOptions.find((e) => e.epic_id === epic)?.epic_name ||
                    '+ Epic'}
                </Text>
              </div>
            </Popover>
          </div>
        )}

        {/* Dates */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Due date</span>
          <DatePicker
            value={dueDate ? dayjs(dueDate) : null}
            onChange={(d, ds) => {
              setDueDate(ds);

              if (subtaskDetails) {
                autoSaveSubtask('due_date', ds);
              } else {
                autoSave('due_date', ds);
              }
            }}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Start date</span>
          <DatePicker
            value={startDate ? dayjs(startDate) : null}
            onChange={(d, ds) => {
              setStartDate(ds);

              if (subtaskDetails) {
                autoSaveSubtask('start_date', ds);
              } else {
                autoSave('start_date', ds);
              }
            }}
          />
        </div>

        {/* Story Points */}
        {!isSubtask && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <span style={{ width: 120, fontWeight: 500 }}>Story points</span>
            <InputNumber
              value={story_points}
              onChange={(value) => {
                setStoryPoints(value);
                dispatch(setStoryPoints(value));
              }}
              onBlur={() => {
                //autoSave('story_points', story_points);

                if (subtaskDetails) {
                  autoSaveSubtask();
                } else {
                  autoSave('story_points', story_points);
                }
              }}
              placeholder="-"
              style={{ width: 120 }}
            />
          </div>
        )}

        {/* Sprint */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Sprint</span>
          <Text>
            {taskdata?.sprint_name || subtaskDetails?.sprint_name || ''}
          </Text>
        </div>

        {/* Priority */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Priority</span>
          <Text>
            {taskdata?.issue_priority || subtaskDetails?.priority || ''}
          </Text>
        </div>

        {/* Reporter */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 500 }}>Reporter</span>
          {/* <Text>{taskdata?.task_created_by_name || 'Unknown'}</Text> */}
          <UserAvatar
            username={
              taskdata?.issue_created_by_name ||
              subtaskDetails?.project_creator_name ||
              'Unassigned'
            }
            size={28}
          />
          <Text>
            {taskdata?.issue_created_by_name ||
              subtaskDetails?.project_creator_name ||
              'Unknown'}
          </Text>
        </div>
      </div>
      <div
        style={{
          marginTop: 20,
          padding: '12px 16px',
          // border: '1px solid #e6e6e6',
          borderRadius: 8,
          // background: '#fff',
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 300 }}>Created at</span>
          <Text style={{ color: '#333' }}>
            {subtaskDetails?.created_at
              ? dayjs(subtaskDetails.created_at).format('DD MMM YYYY, hh:mm A')
              : taskdata?.created_at
              ? dayjs(taskdata.created_at).format('DD MMM YYYY, hh:mm A')
              : 'Unknown'}
          </Text>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ width: 120, fontWeight: 300 }}>Updated at</span>
          <Text style={{ color: '#333' }}>
            {subtaskDetails?.updated_at
              ? dayjs(subtaskDetails.updated_at).format('DD MMM YYYY, hh:mm A')
              : taskdata?.updated_at
              ? dayjs(taskdata.updated_at).format('DD MMM YYYY, hh:mm A')
              : 'Unknown'}
          </Text>
        </div>
      </div>
    </>
  );
};

export default DetailsPage;
